// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "201e3606182c33bdf7b7" + ".chunk.css";
};